import { ENDPOINTS } from '../constants';
import { meta } from '../meta';
import type { CancellableWidgetRequestArgs, SessionStatusData } from '../types';
import { baseFetch } from './base-fetch';
import { getBaseFetchHeaders } from './get-base-fetch-headers';

type GetSessionStatusArgs = CancellableWidgetRequestArgs & {
  sessionId: string;
};

export type GetSessionStatusPayload = SessionStatusData;

export function getSessionStatus({
  sessionId,
  widgetToken,
  abortSignal
}: GetSessionStatusArgs) {
  return baseFetch({
    url: `${meta.paymentServiceUrl}/${ENDPOINTS.getSessionData}/${sessionId}`,
    init: {
      signal: abortSignal,
      headers: getBaseFetchHeaders({ widgetToken })
    },
    handleSuccess: (payload: GetSessionStatusPayload) => payload,
    errorMessage: 'Failed to get session status'
  });
}
